import { createReducer } from "@reduxjs/toolkit";

import { HttpRequestStatus } from "src/shared/types/statuses";
import {
    householdClaimsState,
    HouseholdClaimState as State,
} from "src/redux/claim/household/state";
import {
    householdClaimErrorSummaries,
    HouseholdClaimErrorSummariesAction,
    householdClaimFillSummaries,
    HouseholdClaimFillSummariesAction,
    householdClaimLoadSummaries,
} from "src/redux/claim/household/actions";

class Reducers {
    static loadClaims(state: State): State {
        return {
            ...state,
            status: HttpRequestStatus.PENDING,
        };
    }

    static fillClaims(
        state: State,
        action: HouseholdClaimFillSummariesAction
    ): State {
        return {
            ...state,
            claims: action.payload,
            status: HttpRequestStatus.RESOLVED,
        };
    }

    static handleError(
        state: State,
        action: HouseholdClaimErrorSummariesAction
    ): State {
        return {
            ...state,
            status: HttpRequestStatus.REJECTED,
            error: action.payload,
        };
    }
}

export const householdClaimReducer = createReducer(householdClaimsState, {
    [householdClaimLoadSummaries.type]: Reducers.loadClaims,
    [householdClaimFillSummaries.type]: Reducers.fillClaims,
    [householdClaimErrorSummaries.type]: Reducers.handleError,
});
